export enum Roles {
  MANAGER = 'tak_synapse_manager',
}
